import { URLS } from '@shared/routing';
import { redirect } from '@sveltejs/kit';

import type { PageLoad } from './$types';

export const ssr = false;

export const load = (({ params }) => {
    throw redirect(302, URLS.index(undefined, { refCode: params.refCode }));
}) satisfies PageLoad;
